import { observer } from 'mobx-react';

import Markdown from '../../app/shared/components/Markdown/Markdown';
import { TabList } from '../../app/shared/components/TabList/TabList';
import css from './TermsPage.css';
import { TermsPageState } from './TermsPageState';

interface TermsPageProps {
  state: TermsPageState;
}

const TermsPage = observer(({ state }: TermsPageProps) => {
  return (
    <>
      <TabList
        className={css.tabList}
        tabItemClassName={css.tabItem}
        tabs={state.brandTabs.tabs}
        setActiveTab={state.brandTabs.setActiveTab}
      />
      {state.activeDocument && (
        <article className={css.document} aria-label={state.activeDocument.brandName}>
          {state.activeDocument.paragraphs.map((i) => (
            <Markdown className={css.section} content={i.content} key={i.id} />
          ))}
        </article>
      )}
    </>
  );
});

export default TermsPage;
